// extracted by mini-css-extract-plugin
export var active = "_af-7";
export var blink = "_af-8";
export var dropDownSelector = "_af-4";
export var dropDownWrapper = "_af-3";
export var fakeCursor = "_af-6";
export var fontSizeButton = "_af-9";
export var formQuillEditor = "_af-0";
export var pressed = "_af-a";
export var qlBlank = "_af-1";
export var textFormattingToolbar = "_af-2";
export var textToolbarOption = "_af-5";